<script>
    import { RichTextEditor } from "../../../../Components/Common/index.svelte";

    export let patientEncounterDetails = {};

    // HELPER FUNCTIONS
</script>

<div class="flex flex-col w-full lg:flex-row">
    <div
        class="flex flex-1 h-full card bg-white rounded-box border"
    >
        <div
            class="flex px-4 text-white cursor-default bg-gradient-to-b from-bg-primary to-bg-secondary"
        >
            <p class="font-bold py-4">Notes</p>
        </div>

        <div class="flex flex-col flex-1 p-4 w-full gap-y-4">
            <div class="grid grid-cols-6 gap-x-2 gap-y-4 px-2 w-full">
                <!-- notes -->
                <div class="flex w-full px-2 col-span-6">
                    <!-- <textarea
                        id="notes"
                        class="textarea w-full textarea-bordered"
                        rows="5"
                        autocomplete="off"
                        bind:value={patientEncounterDetails.notes}
                    /> -->
                    <RichTextEditor
                        bind:content={patientEncounterDetails.notes}
                    />
                </div>
            </div>
        </div>
    </div>
</div>
